import { useCallback, useMemo, useState } from "react";
import { useShallow } from "zustand/shallow";
import { usePairs } from "../../store/pairs";

enum MarketTab {
  all = "all",
  crypto = "crypto",
  commodities = "commodities",
  forex = "forex",
  stock = "stock",
}

export const TABS = [
  { title: "All", value: MarketTab.all },
  { title: "Crypto", value: MarketTab.crypto },
  { title: "Forex", value: MarketTab.forex },
  { title: "US Stock", value: MarketTab.stock },

  // nếu sau này có stock thì thêm
];

export function useGetDataPair() {
  const [tab, setTab] = useState<MarketTab | string>(MarketTab.all);

  const data = usePairs(useShallow((state) => state));

  const formatted = useMemo(() => {
    if (!data?.data) return [];

    switch (tab) {
      case MarketTab.crypto:
        return data.data.filter((item) => item.groupName === "crypto");

      case MarketTab.forex:
        return data.data.filter((item) => item.groupName === "forex" || item.groupName.startsWith("commodities"));

      case MarketTab.stock:
        return data.data.filter((item) => item.groupName === "stock");

      case MarketTab.all:
      default:
        return data.data;
    }
  }, [data.data, tab]);

  const filteredPairs = useMemo(() => {
    return formatted;
  }, [formatted]);

  const onChangeTab = useCallback((value: MarketTab | string) => {
    setTab(value);
  }, []);

  return { tab, onChangeTab, formatted: filteredPairs };
}
